import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { BorrowerDetailResponse } from '../../../model/finzy-flex/borrower.model';
import { ConfigService } from "../../config.service";

@Injectable()
export class BorrowerService {
    private readonly httpClient: HttpClient;
    private readonly configService: ConfigService;

    constructor(httpClient: HttpClient, configService: ConfigService) {
        this.httpClient = httpClient;
        this.configService = configService;
    }

    public async getBorrowerDetail(borrowerId: string): Promise<BorrowerDetailResponse> {
        const url = `${this.configService.getUserService_V2_Url()}/user/${borrowerId}`;
        return await this.httpClient.get<BorrowerDetailResponse>(url).toPromise();
    }
}